import { useCallback } from "react";

// Smooth-scroll to a section id, offset for the sticky navbar. Uses Lenis when available.
export const useScrollTo = () =>
  useCallback((id) => {
    const el = document.getElementById(id);
    if (!el) return;
    if (window.__lenis) {
      window.__lenis.scrollTo(el, { offset: -76 });
    } else {
      el.scrollIntoView({ behavior: "smooth" });
    }
  }, []);
